/**
 * Shared tail for user-facing fetch/service error formatters: extract the
 * real error message, log it once (for support/diagnostics — never shown to
 * the user), and return a generic, ops-detail-free fallback sentence.
 *
 * Every scrubbed-error formatter in this app (ZOE investigations, Profit
 * Agent, the operations agent) reimplemented this exact shape
 * (`const raw = err instanceof Error ? ... ; if (raw) console.warn(...); return '<generic>'`).
 * Sharing it means a future change to the logging side (structured telemetry
 * instead of console.warn, a different support-contact line) only needs to
 * land once, instead of being found and applied in every copy.
 */
export function logAndFallback(err: unknown, logPrefix: string, fallbackMessage: string): string {
  const raw = err instanceof Error ? err.message : String(err ?? '');
  if (raw) console.warn(logPrefix, raw);
  return fallbackMessage;
}
